export function getPageRange(currentPage, totalPages, maxVisiblePages) {
  const startPage = Math.max(0, Math.min(currentPage - Math.floor(maxVisiblePages / 2), totalPages - maxVisiblePages));

  const endPage = Math.min(totalPages, startPage + maxVisiblePages);

  return {
    startPage,
    endPage,
    pageNumbers: Array.from({ length: endPage - startPage }, (_, i) => startPage + i + 1),
  };
}

export function getItemRange(currentPage, rowsPerPage, totalItems) {
  if (!totalItems) return { startItem: 0, endItem: 0 };

  const startItem = currentPage * rowsPerPage + 1;
  const endItem = Math.min((currentPage + 1) * rowsPerPage, totalItems);

  return { startItem, endItem };
}
